import { render, staticRenderFns } from "./ViAdmissionAssignTeacher.vue?vue&type=template&id=453ef05a"
import script from "./ViAdmissionAssignTeacher.vue?vue&type=script&lang=js"
export * from "./ViAdmissionAssignTeacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports